import { DownloadIcon } from '~/@mid_ui/icons/DownloadIcon'
import { useDocumentDownloads } from './useDocumentDownloads'
import { Spinner } from '~/shadcn/ui/spinner'
import { Button } from '~/shadcn/ui/button/button'

function DocumentDownloads() {
  const {
    isDownloadingTaxStatement,
    downloadAgreementTaxStatementDocument,
    isDownloadingFeeNotice,
    downloadFeeNoticeDocument,
  } = useDocumentDownloads()

  return (
    <>
      <Button
        variant="outline"
        size="medium"
        className="flex flex-row items-center gap-2"
        disabled={isDownloadingTaxStatement || isDownloadingFeeNotice}
        onClick={() => downloadFeeNoticeDocument()}>
        {isDownloadingFeeNotice ? <Spinner /> : <DownloadIcon />}
        <span>Oznámenie o zavedení poplatkov</span>
      </Button>
      <Button
        variant="outline"
        size="medium"
        disabled={isDownloadingTaxStatement || isDownloadingFeeNotice}
        onClick={() => downloadAgreementTaxStatementDocument()}>
        {isDownloadingTaxStatement ? <Spinner /> : <DownloadIcon />}
        <span>Daňový výpis</span>
      </Button>
    </>
  )
}

export { DocumentDownloads }
